import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUser } from '@fortawesome/pro-solid-svg-icons';

// Modules
import Window from '../../../../../../modules/window';

// Models
import ShareOpportunity from '../../../../../../models/v2/share_opportunity';

// Base
import Button from '../../../../base/button';
import Col from '../../../../base/col';
import Modal from '../../../../base/modal';
import ModalBody from '../../../../base/modal/body';
import ModalHeader from '../../../../base/modal/header';
import Row from '../../../../base/row';

// Form
import Input from '../../../../form/input';

export default class Share extends React.Component {
  static propTypes = {
    opportunity: PropTypes.object.isRequired,
    className: PropTypes.string,
  }

  state = {
    sending: false,
    email: '',
    errorMessages: {},
    isOpen: false,
  }

  handleUpdateEmail = (email) => {
    this.setState({ email });
  }

  handleSubmit = (e) => {
    e && e.preventDefault();

    const { opportunity } = this.props;
    const { sending, email } = this.state;

    if (sending) return;

    if (email == '') {
      this.setState({
        errorMessages: {
          email: 'cannot be blank'
        }
      });
    } else {
      this.setState({ sending: false }, () => {
        (new ShareOpportunity({ email: email }))
          .url(`/api/v2/opportunities/${opportunity.id}/share_opportunities`)
          .save()
          .then(() => {
            Window.flash.success('Successfully Sent Invitations');
            this.handleCloseModal();
          })
        });
    }
  }

  handleOpenModal = () => {
    this.setState({ isOpen: true });
  }

  handleCloseModal = () => {
    this.setState({
      email: '',
      isOpen: false,
    });
  }

  render() {
    const { className } = this.props;
    const { isOpen, errorMessages } = this.state;

    return(
      <React.Fragment>
        <Button {...{
          size: 'custom',
          className: `social-link ${className}`,
          onClick: this.handleOpenModal,
        }} >
          <FontAwesomeIcon icon={faEnvelope} />
        </Button>
        <Modal {...{
          isOpen,
          onClose: this.handleCloseModal,
        }} >
          <ModalHeader>
            Share Job Post
          </ModalHeader>
          <ModalBody>
            <form onSubmit={this.handleSubmit}>
              <Row noMargin>
                <Col s={12}>
                  <Input {...{
                    id: 'user_email',
                    type: 'email',
                    icon: faUser,
                    label: 'Email',
                    onChange: (_, value) => this.handleUpdateEmail(value),
                    placeholder: 'johndoe@example.com',
                    autoFocus: true,
                    errorMessage: errorMessages.email,
                  }} />
                </Col>
                <Col s={12} className='right-align'>
                  <Button {...{
                    text: 'Share Job Post',
                    className:'right-align',
                    onClick: this.handleSubmit,
                  }} />
                </Col>
              </Row>
              <button type='submit' className='hide' />
            </form>
          </ModalBody>
        </Modal>
      </React.Fragment>
    )
  }
}